import * as React           from 'react';
import {
    createDataView,
    deleteDataView,
    updateDataView}         from "../../../../actions/boCoreActions";
import {connect}            from "react-redux";
import {DataTypesEnum}      from "../../enums/dataTypesEnum";
import {AttributeTypeEnum}  from "../../enums/AttributeTypeEnum";
import Utils                from "../../../../Utils";
import AgGridSelect         from './components/AgGridSelect'
import * as toastr          from "toastr";
import LoadingModal         from "../../modals/LoadinModal";
import _                    from "lodash";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "ag-grid-community/dist/styles/ag-theme-balham-dark.css"

const AgGridReact = require('ag-grid-react').AgGridReact;

interface Props {
    dataViewsWrapper: any;
    businessObjects: any;
    businessObjectsWrapper: any,
    cloneDataViewUpdateFlag: any,
    createDataView: any,
    createColumnsOfDataView: any,
    updateDataView: any,
    deleteDataView: any,
    setSelectedDataView: any,
    noSelectedItems: any,
    currentSlide: string;
    configAgGridRef: any
}

interface State {
    columnDefs: any;
    rowData: any;
    gridApi: any;
    columnApi: any;
    loading: boolean;
}

class DataViewConfigAgGrid extends React.Component<Props, State> {
    private selectedRow = null;
    private prevSelected = -1;
    private suppressUpdatingPrevSelected = false;
    private rowData = [];
    private newRow = false;
    private rowDataCopy = [];
    private continueWithoutSaving = false;

    constructor(props: Props) {
        super(props);
        this.state = {
            columnDefs: [],
            rowData: [],
            gridApi: null,
            columnApi: null,
            loading: false
        };
        props.configAgGridRef.current = this;
    }

    componentDidMount(): void {
        $(this.refs.dataViewSearch).focus();
        this.buildGrid(this.props.dataViewsWrapper, this.props.businessObjects);
        document.addEventListener('keydown', this.keydownHandler);
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
        if (this.props.currentSlide !== prevProps.currentSlide && this.props.currentSlide === 'second') {
            document.removeEventListener('keydown', this.keydownHandler);
        }
        if (this.props.currentSlide !== prevProps.currentSlide && this.props.currentSlide === 'first') {
            this.continueWithoutSaving = false;
            this.updateThisRowData();
            this.rowDataCopy = _.cloneDeep(this.rowData)
            document.addEventListener('keydown', this.keydownHandler);
        }
    }

    componentWillUnmount(): void {
        document.removeEventListener('keydown', this.keydownHandler);
    }

    keydownHandler = (e) => {
        if(e.ctrlKey && e.altKey && e.keyCode === 68) {
            Utils.$('#data_view_configuration_delete_btn').click();
        }
        if(e.shiftKey && e.keyCode === 39) {
            Utils.$('#dataViewFormSlide').click();
            this.state.gridApi.clearFocusedCell();
        }
        if(e.ctrlKey && e.altKey && e.keyCode === 78) {
            Utils.$('#data_view_configuration_new_btn').click();
        }
        if(e.ctrlKey && e.altKey && e.keyCode === 83) {
            Utils.$('#data_view_configuration_save_btn').click();
        }
        if(e.shiftKey && e.keyCode === 38) {
            e.preventDefault();
            $(this.refs.dataViewSearch).focus();
        }
        if (e.shiftKey && e.keyCode === 40) {
            e.preventDefault();
            Utils.$('.d-view-grid-1')[0].focus();
            this.state.gridApi.clearFocusedCell();
        }
        if (e.keyCode === 9) {
            e.preventDefault();
            const element = document.activeElement;
            const id = element.id.split('-')[3];

            if (element.classList.contains("d-view-grid-1")) {
                if (Number.parseInt(id) === 3 || Utils.$('.d-view-grid-1').length - 1 === Number.parseInt(id)) {
                    this.setGridFistCellOnFocus(e);
                } else {
                    const index = Number.parseInt(id) + 1;
                    Utils.$('.d-view-grid-1')[index].focus();
                }
            }
        }
    };

    hasChanges = (): boolean => {
        this.state.gridApi.stopEditing();
        if (!this.continueWithoutSaving) {
            this.updateThisRowData();
        }
        return !(_.isEqual(this.rowData, this.rowDataCopy));
    }

    changesPrompt = () => {
        Utils.$.confirm({
            title: 'Confirm?',
            keyboardEnabled: true,
            escapeKey: 'cancel',
            backgroundDismiss: false,
            content: 'There are unsaved changes. Are you sure you want to continue?',
            type: 'red',
            theme: 'dark',
            typeAnimated: false,
            buttons: {
                ok: {
                    text: "Yes!",
                    btnClass: 'btn-danger',
                    keys: ['enter'],
                    action: () => {
                        this.continueWithoutSaving = true;
                        this.rowData = _.cloneDeep(this.rowDataCopy);
                        const selectedRows = this.state.gridApi.getSelectedNodes();
                        const filterModel = this.state.gridApi.getFilterModel();
                        this.state.gridApi.setRowData(this.rowData);
                        this.state.gridApi.setFilterModel(filterModel);
                        setTimeout(() => {
                            this.state.gridApi.selectIndex(selectedRows[0].rowIndex, false, true)
                        }, 200)

                        Utils.$('#dataViewFormSlide').click();
                    }
                },
                cancel: () => {
                    this.continueWithoutSaving = false;
                }
            }
        });
    }

    /**
     * Summary:
     * This method gets all the data from the grid.
     */
    updateThisRowData = () => {
        this.rowData = [];
        this.state.gridApi.forEachNode(node => this.rowData.push(node.data));
    };

    setGridFistCellOnFocus = (event) => {
        if (event.keyCode === 9) {
            event.preventDefault();

            // scrolls to the first row
            this.state.gridApi.ensureIndexVisible(0);

            // scrolls to the current column
            let currentCol = this.state.columnApi.getAllDisplayedColumns()[0];
            this.state.gridApi.ensureColumnVisible(currentCol);

            // sets focus into the grid cell
            this.state.gridApi.setFocusedCell(0, currentCol);
        }
    };

    onFilterTextBoxChanged = (e) => {
        if (e.ctrlKey && e.altKey) {
            e.preventDefault();
        }
        this.setGridFistCellOnFocus(e);
    };

    buildGrid = (dataViewsWrapper, businessObjects) => {
        const rowData = dataViewsWrapper.getDataViews(DataTypesEnum.ARRAY).sort((a, b) => {
            if (a.businessObjectClass.name > b.businessObjectClass.name) {
                return 1;
            }
            if (a.businessObjectClass.name < b.businessObjectClass.name) {
                return -1;
            }
            return 0;
        }).map(item => {return {id: item.id, boClass: {id: item.businessObjectClass.id, name: item.businessObjectClass.name}, viewName: item.viewName, isDefault: item.isDefault, isActive: item.isActive, columns: item.columns}});

        this.rowDataCopy = _.cloneDeep(rowData);

        businessObjects = businessObjects.sort((a, b) => {
            if (a.name > b.name) {
                return 1;
            }
            if (a.name < b.name) {
                return -1;
            }
            return 0;
        });
        const columnDefs = [
            {
                field: "quickFilter", hide: true, lockVisible: true,
                dataType: AttributeTypeEnum.TEXT
            },
            {
                id: "name",
                headerName: "Bo Type",
                field: "boClass",
                headerTooltip: "Bo Type",
                minWidth: 200,
                sortable: true,
                type: 'value list',
                options: businessObjects,
                editable: true,
                cellEditor: 'agSelect',
                checkboxSelection: true,
                getQuickFilterText: function (params) {
                    return params.value.name
                },
                cellRenderer: function (params) {
                    return `<span>${params.value.name}</span>`
                },
                filterParams: {
                    valueGetter: params => {
                        return params.data.boClass.name
                    }
                },
                comparator: function (valueA, valueB) {
                    if (valueA.name == valueB.name) {
                        return 0;
                    } else {
                        return (valueA.name > valueB.name) ? 1 : -1;
                    }
                }
            },
            {
                field: 'viewName',
                headerName: "View Name",
                tooltipField: 'view name',
                headerTooltip: "View Name",
                width: 200,
                type: 'text',
                editable: true,
            },
            {
                field: 'isDefault',
                headerName: "Is Default",
                tooltipField: 'isDefault',
                headerTooltip: "Is Default",
                width: 100,
                editable: true,
                cellEditor: 'agRichSelectCellEditor',
                cellEditorParams: {
                    values: [true, false]
                }
            },
            {
                editable: true,
                field: 'isActive',
                colKey: 'isActive',
                headerName: "Is Active",
                tooltipField: 'isActive',
                width: 100,
                cellEditor: 'agRichSelectCellEditor',
                cellEditorParams: {
                    values: [true, false]
                }
            },
        ];

        this.setState({rowData, columnDefs}, () => {
            Utils.$("#dataViewConfigurationGrid").find('.ag-floating-filter-input').each(function( index ) {
                Utils.$(this).attr('id', 'dView-search-filter-' + index);
                Utils.$(this).addClass('d-view-grid-1');
                Utils.$(this).attr('index', (index + 2));
            });
        });
    };

    onGridReady = (params) => {
        params.api.sizeColumnsToFit();
        this.setState({
            gridApi: params.api,
            columnApi: params.columnApi
        });
    };

    onSelectionChanged = (params) => {
        this.suppressUpdatingPrevSelected = false;
        const selectedRows = params.api.getSelectedNodes();
        this.selectedRow = selectedRows[0];
        if (selectedRows.length === 0) {
            this.props.noSelectedItems();
            return;
        }

        if (selectedRows.length > 0 && this.selectedRow.data.id !== -1) {
            this.updateThisRowData();
            if (this.selectedRow.rowIndex !== this.prevSelected) {
                if (!(_.isEqual(this.rowData, this.rowDataCopy))) {
                    Utils.$.confirm({
                        title: 'Confirm?',
                        keyboardEnabled: true,
                        escapeKey: 'cancel',
                        backgroundDismiss: false,
                        content: 'There are unsaved changes. Do you want to save them?',
                        type: 'red',
                        theme: 'dark',
                        typeAnimated: false,
                        buttons: {
                            ok: {
                                text: "Yes!",
                                btnClass: 'btn-success',
                                keys: ['enter'],
                                action: () => {
                                    this.suppressUpdatingPrevSelected = true;
                                    this.state.gridApi.selectIndex(this.prevSelected, false, true);
                                    setTimeout(() => {
                                        this.onSave();
                                    }, 200)
                                }
                            },
                            discard: {
                                text: "Discard Changes",
                                btnClass: 'btn-danger',
                                action: () => {
                                    const selectedRows = this.state.gridApi.getSelectedNodes();
                                    this.rowData = _.cloneDeep(this.rowDataCopy);
                                    const filterModel = this.state.gridApi.getFilterModel();
                                    this.state.gridApi.setRowData(this.rowData);
                                    this.state.gridApi.setFilterModel(filterModel);
                                    Utils.$("#data_view_configuration_new_btn").prop("disabled", false);
                                    this.suppressUpdatingPrevSelected = false;
                                    setTimeout(() => {
                                        if (this.newRow) {
                                            const index = selectedRows[0].rowIndex - 1;
                                            this.state.gridApi.selectIndex(index, false, true)
                                        } else {
                                            this.state.gridApi.selectIndex(selectedRows[0].rowIndex, false, true)
                                        }
                                        this.newRow = false;
                                    }, 200)
                                }
                            },
                            cancel: () => {
                                this.suppressUpdatingPrevSelected = true;
                                setTimeout(() => {
                                    this.state.gridApi.stopEditing();
                                    this.state.gridApi.selectIndex(this.prevSelected, false, true)
                                }, 200)
                            }
                        }
                    });
                    return;
                }
            }
            const dataViewObj = this.props.dataViewsWrapper.getDataView(this.selectedRow.data.id);
            if (dataViewObj.isDefault || this.selectedRow.data.viewName === 'full'){
                Utils.$("#data_view_configuration_delete_btn").prop("disabled", true);
            } else {
                Utils.$("#data_view_configuration_delete_btn").prop("disabled", false);
            }
            this.props.setSelectedDataView(this.selectedRow);
            return;
        }
        if (this.selectedRow.data.id === -1) {
            Utils.$("#data_view_configuration_delete_btn").prop("disabled", false);
            this.props.noSelectedItems('Please select existing data view.');
        }
    };

    onFilterChanged = (params) => {
        params.api.deselectAllFiltered();
        params.api.deselectAll();
        let filteredNodes = [];
        params.api.forEachNodeAfterFilter((node) => {
            filteredNodes.push(node);
        });
    };

    onInput = (e) => {
        this.state.gridApi.setQuickFilter(e.currentTarget.value);
        this.state.gridApi.sizeColumnsToFit();
    };

    resetFilters = () => {
        Utils.$(this.refs.dataViewSearch).val('');
        this.state.gridApi.setQuickFilter('');
        this.state.gridApi.sizeColumnsToFit();
        this.state.gridApi.setFilterModel(null);
    };

    resetSorting = () => {
        this.state.gridApi.setSortModel(null);
    }

    addRow = () => {
        this.newRow = true;
        this.resetFilters();
        this.resetSorting();
        this.state.gridApi.updateRowData({ add: [{id: -1, boClass: {id: -1, name: ''}, viewName: '', isDefault: false, isActive: true}], addIndex: 0 });
        Utils.$("#data_view_configuration_new_btn").prop("disabled", true);
        Utils.$("#data_view_configuration_delete_btn").prop("disabled", false);
        this.state.gridApi.startEditingCell({
            rowIndex: 0,
            colKey: this.state.columnApi.getAllColumns()[1].colId
        });
        setTimeout(() => {
            this.state.gridApi.selectIndex(0, false, true);
        }, 100);
        this.updateThisRowData();
    };

    deleteRow = () => {
        const selectedData = this.state.gridApi.getSelectedRows();
        if (selectedData.length === 0) {
            toastr.warning('Please select a row you want to delete.');
            return;
        }
        this.state.gridApi.stopEditing();
        if (selectedData[0].id !== -1) {
            let confirm = Utils.$.confirm({
                title: 'Confirm?',
                keyboardEnabled: true,
                escapeKey: 'cancel',
                backgroundDismiss: false,
                content: 'You are about to delete one data view, this procedure is irreversible.',
                type: 'red',
                theme: 'dark',
                typeAnimated: false,
                buttons: {
                    ok: {
                        text: "Yes!",
                        btnClass: 'btn-danger',
                        keys: ['enter'],
                        action: () => {
                            confirm = null;
                            this.setState({loading: true});
                            this.props.deleteDataView(selectedData[0].id, () => {
                                this.state.gridApi.updateRowData({ remove: selectedData });
                                this.state.gridApi.refreshCells({ force: true });
                                this.updateThisRowData();
                                this.rowDataCopy = _.cloneDeep(this.rowData);
                                this.setState({
                                    loading: false
                                });
                            },() => {
                                //Error
                                this.setState({loading: false});
                                this.updateThisRowData();
                            });
                        }
                    },
                    cancel: function () {
                        confirm = null;
                    }
                }
            });
        } else {
            this.state.gridApi.updateRowData({ remove: selectedData });
            this.state.gridApi.refreshCells({ force: true });
        }
        Utils.$("#data_view_configuration_new_btn").prop("disabled", false);
    };

    onSave = () => {
        this.state.gridApi.stopEditing();
        const selectedData = this.state.gridApi.getSelectedRows();
        if (selectedData.length === 0) {
            toastr.warning('Please select one row')
        } else {
            this.updateThisRowData();
            if (selectedData[0].viewName === '') {
                toastr.warning('View name must not be empty string');
                return;
            }
            if (selectedData[0].boClass.id === -1) {
                toastr.warning('Please select BO Type');
                return;
            }
            if ((_.isEqual(this.rowData, this.rowDataCopy))) {
                toastr.warning('There are no changes');
                return;
            }
            this.updateDataView();
        }
    };

    updateDataView = () => {
        this.setState({
            loading: true
        });
        // Update
        if (this.selectedRow.data.id !== -1) {
            const dto = {
                viewName: this.selectedRow.data.viewName,
                isActive: this.selectedRow.data.isActive,
                isDefault: this.selectedRow.data.isDefault,
                active: this.selectedRow.data.isActive
            };
            this.props.updateDataView(this.selectedRow.data.id, dto, () => {
                Utils.$("#data_view_configuration_new_btn").prop("disabled", false);
                this.updateThisRowData();
                this.rowData.forEach((dataView, index) => {
                    if (dataView.boClass.name === this.selectedRow.data.boClass.name && dataView.id !== this.selectedRow.data.id) {
                        if (this.selectedRow.data.isDefault) {
                            Utils.$("#data_view_configuration_delete_btn").prop("disabled", true);
                            this.rowData[index].isDefault = false;
                        } else {
                            const dataViewObj = this.props.dataViewsWrapper.getDataView(this.selectedRow.data.id);
                            Utils.$("#data_view_configuration_delete_btn").prop("disabled", false);
                            if (dataViewObj.isDefault !== this.selectedRow.data.isDefault && dataView.viewName === 'full') {
                                this.rowData[index].isDefault = true;
                            }
                        }
                    }
                })
                dto['id'] = this.selectedRow.data.id;
                this.props.dataViewsWrapper.updateDataView(dto)
                this.setState({
                    loading: false,
                    rowData: this.rowData
                }, () => this.state.gridApi.refreshCells({ force: true }));
                this.rowDataCopy = _.cloneDeep(this.rowData);
            }, (e) => {
                //Error
                this.setState({
                    loading: false
                }, () => this.editExistingName(e, true));
            });
        } else {
            // Create
            this.props.createDataView(this.selectedRow.data.boClass.id, {
                viewName: this.selectedRow.data.viewName,
                isActive: this.selectedRow.data.isActive,
                isDefault: this.selectedRow.data.isDefault,
                active: this.selectedRow.data.isActive
            }, (response) => {
                this.newRow = false;
                Utils.$("#data_view_configuration_new_btn").prop("disabled", false);

                this.selectedRow.data.id = response.data.id;
                response.data.columns = response.data.columns || [];
                this.props.dataViewsWrapper.addDataView(response.data);
                this.state.gridApi.deselectAll();
                this.updateThisRowData();
                if (this.selectedRow.data.isDefault) {
                    this.rowData.forEach((dataView, index) => {
                        if (dataView.boClass.name === this.selectedRow.data.boClass.name && dataView.id !== this.selectedRow.data.id) {
                            this.rowData[index].isDefault = false;
                        }
                    })
                    this.setState({
                        loading: false,
                        rowData: this.rowData
                    }, () => this.state.gridApi.refreshCells({ force: true }));
                } else {
                    this.setState({
                        loading: false
                    });
                }
                this.rowDataCopy = _.cloneDeep(this.rowData);
            }, (e) => {
                //Error
                this.setState({
                    loading: false
                }, () => this.editExistingName(e, false));
            });
        }
    };

    editExistingName = (e, isUpdating) => {
        if (e.response.data?.message.includes('There already is a Data View with name')) {
            Utils.$("#data_view_configuration_new_btn").prop("disabled", true);
            this.state.gridApi.startEditingCell({
                rowIndex: this.selectedRow ? this.selectedRow.rowIndex : 0,
                colKey: this.state.columnApi.getAllColumns()[2].colId
            });
            return;
        }
        if (e.response.data?.message.includes('Can\'t rename the data view. \'full\' is not allowed')) {
            Utils.$("#data_view_configuration_new_btn").prop("disabled", true);
            this.state.gridApi.startEditingCell({
                rowIndex: this.selectedRow ? this.selectedRow.rowIndex : 0,
                colKey: this.state.columnApi.getAllColumns()[2].colId
            });
        } else {
            if (!isUpdating) {
                const selectedData = this.state.gridApi.getSelectedRows();
                this.state.gridApi.updateRowData({ remove: selectedData });
                this.state.gridApi.refreshCells({ force: true });
            }
        }
    };

    cellEditorHandler = (params) => {
        if (params.colDef.type === AttributeTypeEnum.VALUE_LIST && params.data.id !== -1) {
            params.api.stopEditing();
        }
        if (params.data.id !== -1) {
            let dataView = this.props.dataViewsWrapper.getDataView(params.data.id);
            if (!dataView) {
                dataView = params.data;
            }

            if (dataView.viewName === 'full') {
                params.api.stopEditing();
            } else if ((params.colDef.field === 'viewName' ||
                params.colDef.field === 'isActive') && dataView.isDefault) {
                params.api.stopEditing();
            }
        }
    };

    onRowSelected = (params) => {
        if (!params.node.selected && !this.suppressUpdatingPrevSelected) {
            this.prevSelected = params.node.childIndex;
        }
    }

    render() {
        return (
            <div style={{height: '100%'}}>
                <LoadingModal open={this.state.loading}/>
                <div className="bo-core-header text-right background-gradient" style={{marginBottom: 3, paddingRight: 0, paddingTop: 5, display: 'flex'}}>
                    <div className={'dataViewsSearch'}>
                        <input placeholder="🔍 Search - Shift + UpArrow & Shift + DownArrow" className="new-design" tabIndex={1} ref={'dataViewSearch'}
                               style={{width: "100%", height: 36, fontSize: 18}} onKeyDown={this.onFilterTextBoxChanged} onChange={this.onInput}
                               id={"dataViewConfigurationGrid-search"} type="search"/>
                    </div>

                    <div className={'dataViewsBtns'}>
                        <button style={{marginRight: 5}} id="data_view_configuration_new_btn"
                                onClick={this.addRow} title={'CTRL + ALT + N'}
                                className="btn btn-success">
                            <i className="fas fa-plus"/> <strong style={{fontSize: '13px'}} className={'shortcut-btn-letters'}>N</strong>ew
                        </button>
                        {/*<button style={{marginRight: 5}} disabled id="data_view_configuration_clone_btn"*/}
                        {/*className="btn btn-warning">Clone*/}
                        {/*</button>*/}
                        <button style={{marginRight: 5}}
                                id="data_view_configuration_save_btn"
                                onClick={this.onSave}
                                title={'CTRL + ALT + S'}
                                className="btn btn-primary">
                            <i className="fas fa-save"/> <strong style={{fontSize: '13px'}} className={'shortcut-btn-letters'}>S</strong>ave
                        </button>
                        <button style={{marginRight: '2px'}}
                                id="data_view_configuration_delete_btn"
                                className="btn btn-danger"
                                title={'CTRL + ALT + D'}
                                onClick={this.deleteRow}>
                            <i className="fas fa-trash-alt"/> <strong style={{fontSize: '13px'}} className={'shortcut-btn-letters'}>D</strong>elete
                        </button>
                    </div>
                </div>

                <div id="grid_container" style={{
                    borderBottom: "2px solid black",
                    height: "calc(100% - 39px)",
                    margin: 0,
                    padding: 0,
                    width: "100%"
                }}>
                    <div className="ag-theme-balham-dark ag-grids"
                         style={{backgroundColor: "#353535", width: "100%", height: "100%", paddingBottom: '10px'}}
                         id="DataViewObjectsGrid">
                        <AgGridReact
                            onGridReady         = {this.onGridReady}
                            onFirstDataRendered = {this.onGridReady}
                            columnDefs          = {this.state.columnDefs}
                            rowData             = {this.state.rowData}
                            onSelectionChanged  = {this.onSelectionChanged}
                            onFilterChanged     = {this.onFilterChanged}
                            onRowSelected       = {this.onRowSelected}
                            defaultColDef={{
                                minWidth: 150,
                                filter: "agTextColumnFilter",
                                sortable: true,
                                floatingFilterComponentParams: {suppressFilterButton: true},
                            }}
                            gridOptions={{
                                floatingFilter: true,
                                resizable: true,
                                singleClickEdit: true,
                                suppressDragLeaveHidesColumns: true,
                                rowSelection: "single",
                                cacheQuickFilter: Utils.$(this.refs.dataViewSearch),
                                components: {
                                    agSelect: AgGridSelect()
                                },
                                onCellEditingStarted: this.cellEditorHandler
                            }}
                        >
                        </AgGridReact>
                    </div>
                </div>

            </div>
        );
    }
}


const mapStateToProps = (state, ownProps) => {
    return {
        businessObjectsWrapper: state.boCore.businessObjectsWrapper,
        cloneDataViewUpdateFlag: state.boCore.cloneDataViewUpdateFlag,

        dataViewsWrapper: state.boCore.dataViewsWrapper,
        businessObjects: ownProps.businessObjects,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        createDataView: (id, args, callBack, errCallBack) => {
            dispatch(createDataView(id, args, callBack, errCallBack));
        },
        // createColumnsOfDataView: (id, dto) => {
        //     dispatch(createColumnsOfDataView(id, dto));
        // },
        updateDataView: (id, args, callBack, errCallBack) => {
            dispatch(updateDataView(id, args, callBack, errCallBack));
        },
        deleteDataView: (id, callBack, errCallBack) => {
            dispatch(deleteDataView(id, callBack, errCallBack));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DataViewConfigAgGrid)



// WEBPACK FOOTER //
// ./app/components/bo-core/grids/DataViewConfigAgGrid/DataViewConfigAgGrid.tsx